import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import BookingDataService from "../../services/Booking";
import { useNavigate } from "react-router-dom";
import { Issues, expert } from "../../Config/Expert";
import { MultiSelect } from "react-multi-select-component";
import { BookingDetails } from "../../Config/Booking";
import ExpertDataService from "../../services/Expert";
import Select from "react-select";
import NotificationService from "../../services/Notification";
import { FormControl, FormLabel, Switch, useToast } from "@chakra-ui/react";
import { DateTime } from "luxon";
export const AddProvisionalBooking = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const location = useLocation();
  const token = localStorage.getItem("logged_in_user_token");
  const loggedInUserEmail = localStorage.getItem("logged_in_email");
  const { bookingData, isBookingProvisional } = location.state || {};

  const [corporateList, setCorporateList] = useState([]);
  const [accessCode, setAccessCode] = useState("");
  const [isValidate, setIsValidate] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [isProvisional, setIsProvisional] = useState(
    isBookingProvisional || true
  );
  const [symptoms, setSymptoms] = useState<any>([]);
  const [expertList, setExpertList] = useState<any>([]);
  const [userList, setUserList] = useState<any>([]);
  const [bookingDate, setBookingDate] = useState("");
  const [isCorporate, setIsCorporate] = useState("");
  const [source, setSource] = useState("");
  const [sessionDate, setSessionDate] = useState("");
  const [sessionCount, setSessionCount] = useState("");
  const [bookingTime, setBookingTime] = useState("");
  const [bookingPostStatus, setBookingPostStatus] = useState("");
  const [sessionTime, setSessionTime] = useState("");
  const [paymentInformation, setPaymentInformation] = useState({
    amount: "0",
    payment_id: "PORTAL_BOOKING",
  });
  const [leadInformation, setLeadInformation] = useState(
    // bookingData.lead_information ||
    {
      uuid: "",
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
    }
  );
  const [expertInformation, setExpertInformation] = useState({
    uuid: "",
    full_name: "",
    role: "",
  });
  const [cartInformation, setCartInformation] = useState({
    promocode: "",
    original_price: "",
    final_price: "",
    subscription: false,
    pro: false,
  });
  const [subscriptionInformation, setSubscriptionInformation] = useState({
    session_count: "",
    price: "",
  });
  const [manoProInformation, setManoProInformation] = useState({
    term_length: "",
    price: "",
    module: "",
  });

  const [therapyPlusInformation, setTherapyPlusInformation] = useState({
    term_length: "",
    price: "",
  });
  const [therapyInformation, setTherapyInformation] = useState({
    gender: "",
    age: 0,
    symptoms: [],
    notes: "",
  });
  const [physicalInformation, setphysicalInformation] = useState({
    address: "",
    city: "",
    state: "",
    latitude: "",
    longitude: "",
    pin_code: "",
  });

  const allowedEmails = [
    "tamannar@manoshala.com",
    "ceooffice@manoshala.com",
    "ayushs@manoshala.com",
  ];

  const isLoggedInUserAllowed =
    loggedInUserEmail !== null && allowedEmails.includes(loggedInUserEmail);

  // Provisional bookings may be back-dated, but only as far back as the first
  // day of the previous calendar month. e.g. any day in Sep -> min is Aug 1;
  // on Oct 1 the window rolls forward to Sep 1.
  const minSessionDate = DateTime.now()
    .setZone("Asia/Kolkata")
    .startOf("month")
    .minus({ months: 1 })
    .toFormat("yyyy-MM-dd");

  const handleSwitchChange = (event: any) => {
    setIsProvisional(event.target.checked);
  };
  const handlePhysicalSessionChange = (e: any) => {
    setphysicalInformation({
      ...physicalInformation,
      [e.target.name]: e.target.value,
    });
  };
  const handlePaymentChange = (e: any) => {
    setPaymentInformation({
      ...paymentInformation,
      [e.target.name]: e.target.value,
    });
  };
  const handleLeadChange = (e: any) => {
    setLeadInformation({ ...leadInformation, [e.target.name]: e.target.value });
  };
  const handleExpertChange = (e: any) => {
    setExpertInformation({
      ...expertInformation,
      [e.target.name]: e.target.value,
    });
  };
  const handleCartChange = (e: any) => {
    let value = e.target.value;
    if (e.target.name === "subscription" || e.target.name === "pro") {
      value = convertToBoolean(value);
    }
    setCartInformation({ ...cartInformation, [e.target.name]: value });
  };
  const handleSubscriptionChange = (e: any) => {
    setSubscriptionInformation({
      ...subscriptionInformation,
      [e.target.name]: e.target.value,
    });
  };
  const handleProChange = (e: any) => {
    setManoProInformation({
      ...manoProInformation,
      [e.target.name]: e.target.value,
    });
  };

  const handleTherapyPlusChange = (e: any) => {
    setTherapyPlusInformation({
      ...therapyPlusInformation,
      [e.target.name]: e.target.value,
    });
  };

  const handleTherapyChange = (e: any) => {
    let value = e.target.value;
    if (e.target.name === "age") {
      value = Number(value);
    }
    setTherapyInformation({
      ...therapyInformation,
      [e.target.name]: value,
    });
  };
  const formattedTime = (inputTime: string) => {
    const parts = inputTime.split(":");

    if (parts.length === 2) {
      let hour = parseInt(parts[0], 10);
      const minute = parts[1];
      let meridiem = "AM";

      if (hour >= 12) {
        meridiem = "PM";
        if (hour > 12) {
          hour -= 12;
        }
      }

      if (hour === 0) {
        hour = 12;
      }

      const formattedTime = `${hour}:${minute} ${meridiem}`;

      return formattedTime;
    }
    return "";
  };
  const formattedDate = (inputDate: string) => {
    const parts = inputDate.split("-");

    if (parts.length === 3) {
      const formattedDate = `${parts[1]}/${parts[2]}/${parts[0]}`;
      return formattedDate;
    }
    return "";
  };
  const handleBookingDateChange = (e: any) => {
    setBookingDate(e.target.value);
  };
  const handleBookingTimeChange = (e: any) => {
    setBookingTime(e.target.value);
  };
  const handleSessionDateChange = (e: any) => {
    setSessionDate(e.target.value);
  };
  const handleSessionTimeChange = (e: any) => {
    setSessionTime(e.target.value);
  };
  const [bookingDetails, setBookingDetails] = useState<any>(
    bookingData ?? BookingDetails
  );

  console.log(bookingDetails, isBookingProvisional);

  const handleChange = (e: any) => {
    let value = e.target.value;

    setBookingDetails({
      ...bookingDetails,
      [e.target.name]: value,
    });
  };
  const convertToBoolean = (value: string) => {
    if (typeof value === "boolean") {
      return value;
    }

    if (typeof value === "string") {
      const lowerCaseValue = value.toLowerCase();
      if (lowerCaseValue === "yes" || lowerCaseValue === "true") {
        return true;
      }
      if (
        lowerCaseValue === "no" ||
        lowerCaseValue === "false" ||
        lowerCaseValue === ""
      ) {
        return false;
      }
    }

    return Boolean(value);
  };
  const options = expertList.map((el: any) => ({
    value: el._id,
    label: el.data.full_name,
  }));
  const userOptions = userList.map((el: any) => ({
    value: el.uuid,
    label: el.label,
  }));

  const handleSubmit = (event: any) => {
    event.preventDefault();

    if (sessionDate && sessionDate < minSessionDate) {
      toast({
        position: "top",
        title: "Booking Validation",
        description: `Session date cannot be earlier than ${DateTime.fromISO(
          minSessionDate
        ).toFormat("dd LLL yyyy")}.`,
        status: "error",
        duration: 4000,
        isClosable: true,
      });
      return;
    }

    if (isCorporate !== "yes" || isValid) {
      const leadSymptoms = symptoms.map((el: { value: any }) => el.value);
      const therapyInfo = { ...therapyInformation, symptoms: leadSymptoms };
      const data = {
        ...bookingDetails,
        non_app: isProvisional,
        session_date: formattedDate(sessionDate),
        session_date_iso: sessionDate,
        session_time: formattedTime(sessionTime),
        session_date_time: DateTime.fromISO(
          `${sessionDate}T${sessionTime}`
        ).toFormat("yyyy-MM-dd'T'HH:mm:ss.SSS"),
        booking_date: formattedDate(bookingDate),
        booking_time: bookingTime,
        payment_information: paymentInformation,
        lead_information: leadInformation,
        expert_information: expertInformation,
        cart_information: cartInformation,
        subscription: {
          session_count: sessionCount,
          price: cartInformation.final_price,
        },
        manoshala_pro: manoProInformation,
        therapy_plus: therapyPlusInformation,
        therapy_note: therapyInfo,
        physical_session_address: physicalInformation,
        expert_billing_details: {
          isCorporate: isCorporate === "yes" ? true : false,
          booking_source: source,
        },
        post_session_status: bookingPostStatus,
      };
      if (isProvisional) {
        BookingDataService.createProvisionalBooking(data)
          .then((response: any) => {
            navigate("/provisional/bookings");
          })
          .catch((e: Error) => {
            console.log(e);
          });
      } else {
        BookingDataService.createBooking(data)
          .then((response: any) => {
            navigate("/");
          })
          .catch((e: Error) => {
            console.log(e);
          });
      }
    }
  };

  const handleExpertDetails = (value: any) => {
    const data = expertList.find((el: any) => el._id === value);
    if (data) {
      setExpertInformation({
        ...expertInformation,
        uuid: value,
        full_name: data.data.full_name,
        role: data.data.role,
      });
    } else {
      setExpertInformation({
        uuid: "",
        full_name: "",
        role: "",
      });
    }
  };
  const handleUseretails = (value: any) => {
    const data = userList.find((el: any) => el.uuid === value);
    if (data) {
      setLeadInformation({
        ...leadInformation,
        uuid: value,
        email: data.label,
      });
    }
  };
  const fetchExperts = async () => {
    try {
      const expertRes = await ExpertDataService.getExperts(token);
      setExpertList(expertRes.data);

      const userRes = await NotificationService.getAllUsers();
      setUserList(userRes.data);

      try {
        const corporateRes = await BookingDataService.getCorporatesDetails(
          token
        );
        setCorporateList(corporateRes.data);
      } catch (error: any) {
        if (error.response && error.response.status === 401) {
          toast({
            position: "top",
            title: "Authentication Failed.",
            description: "Your session is expired.",
            status: "error",
            duration: 500,
            isClosable: true,
          });
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
        console.log(error);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const isCurrentDateWithinRange = (start_date: string, end_date: string) => {
    const currentDate = DateTime.now().startOf("day");
    const startDate = DateTime.fromISO(start_date).startOf("day");
    let endDate = end_date ? DateTime.fromISO(end_date).startOf("day") : null;

    if (!startDate.isValid) {
      return false;
    }

    if (endDate && !endDate.isValid) {
      return false;
    }

    if (endDate) {
      return currentDate >= startDate && currentDate <= endDate;
    } else {
      return currentDate >= startDate;
    }
  };
  const getSingleSessionUnitPrice = (priceData: any, bookingType: string) => {
    return bookingType === "inperson"
      ? priceData.session_price["in_person"]
      : priceData.session_price[bookingType];
  };  
  const getSubscriptionPrice = (
    priceData: any,
    bookingType: string,
    sessionCount: number
  ) => {
    const packKeyMap: Record<number, string> = {
      3: "three_session",
      5: "five_session",
      10: "ten_session",
    };
    const sessionKey = packKeyMap[sessionCount];
    if (!sessionKey) {
      throw new Error("Invalid session count");
    }    
    switch (bookingType) {
      case "inperson":
        return priceData.in_person_subscription_price[sessionKey];
      case "video":
        return priceData.subscription_price[sessionKey];
      case "call":
        return priceData.call_subscription_price[sessionKey];
      case "chat":
        return priceData.chat_subscription_price[sessionKey];
      default:
        throw new Error("Invalid booking type.");
    }
  };
  const calculatePrice = (
    priceData: any,
    bookingType: any,
    sessionCount: number
  ) => {
    if (sessionCount === 1) {
       return getSingleSessionUnitPrice(priceData, bookingType);
    }

    if ([3, 5, 10].includes(sessionCount)) {
      return getSubscriptionPrice(priceData, bookingType, sessionCount);
    }

    if ([2, 4, 6, 7, 8, 9].includes(sessionCount)) {
      return String(
        Number(getSingleSessionUnitPrice(priceData, bookingType)) * sessionCount
      );
    }

    throw new Error("Invalid session count");
  };

  const showToast = (type: any, message: any) => {
    toast({
      position: "top",
      title: "Booking Validation",
      description: message,
      status: type,
      duration: 500,
      isClosable: true,
    });
  };

  const validateDateRange = (startDate: string, endDate: string) => {
    return isCurrentDateWithinRange(startDate, endDate);
  };

  const validateExpert = (
    expert: any,
    specificTherapistOnly: any,
    specificTherapistList: any
  ) => {
    if (!specificTherapistOnly) return true;
    return specificTherapistList.includes(expert.data.manoshala_id);
  };

  const calculateExpertPrice = (
    expert: any,
    bookingType: any,
    sessionCount: any
  ) => {
    return Number(
      calculatePrice(
        {
          session_price: expert.data.app_info.session_price,
          subscription_price: expert.data.app_info.subscription_price,
          chat_subscription_price: expert.data.app_info.chat_subscription_price,
          in_person_subscription_price:
            expert.data.app_info.in_person_subscription_price,
          call_subscription_price: expert.data.app_info.call_subscription_price,
        },
        bookingType,
        Number(sessionCount)
      )
    );
  };

  const validateCorporateBooking = () => {
    const toastMessage = { type: "error", message: "" };

    if (!accessCode) {
      toastMessage.message = "Please select access code";
      showToast(toastMessage.type, toastMessage.message);
      return;
    }

    const corporate = corporateList.find(
      (el: any) => el.access_code === accessCode
    );
    if (!corporate) {
      toastMessage.message = "Corporate not found.";
      showToast(toastMessage.type, toastMessage.message);
      return;
    }

    const {
      validate_users,
      user_emails,
      specific_therapist_only,
      specific_therapist_list,
      contract_start_date,
      contract_end_date,
      current_corporate_balance,
    }: any = corporate;

    const expert = expertList.find(
      (el: any) => el._id === expertInformation.uuid
    );

    if (validate_users && !user_emails.includes(leadInformation.email)) {
      toastMessage.message = "User email is not valid.";
      showToast(toastMessage.type, toastMessage.message);
      return;
    }

    if (specific_therapist_only && !expert) {
      toastMessage.message = "Expert not found.";
      showToast(toastMessage.type, toastMessage.message);
      return;
    }

    if (
      !validateExpert(expert, specific_therapist_only, specific_therapist_list)
    ) {
      toastMessage.message = "Expert not found.";
      showToast(toastMessage.type, toastMessage.message);
      return;
    }

    if (!validateDateRange(contract_start_date, contract_end_date)) {
      toastMessage.message = "Contract ended.";
      showToast(toastMessage.type, toastMessage.message);
      return;
    }

    const expert_price = calculateExpertPrice(
      expert,
      bookingDetails.booking_type,
      sessionCount
    );

    if (current_corporate_balance < expert_price) {
      toastMessage.message = "Corporate balance is low.";
      showToast(toastMessage.type, toastMessage.message);
      return;
    }

    setIsValid(true);
    toastMessage.type = "success";
    toastMessage.message = "Booking is valid.";
    showToast(toastMessage.type, toastMessage.message);
  };

  const convertDateFormat = (inputDate: any) => {
    if (inputDate) {
      const parts = inputDate.split("/");

      const month = parts[0].padStart(2, "0");
      const day = parts[1].padStart(2, "0");
      const year = parts[2];
      const newDateFormat = `${year}-${month}-${day}`;
      return newDateFormat;
    }
    return "";
  };
  const convertTo24HourFormat = (timeString: string) => {
    if (timeString) {
      const [time, period] = timeString.split(" ");
      const [hours, minutes] = time.split(":");

      let newHours = parseInt(hours, 10);
      if (period === "PM" && newHours !== 12) {
        newHours += 12;
      } else if (period === "AM" && newHours === 12) {
        newHours = 0;
      }

      const newTime = `${newHours.toString().padStart(2, "0")}:${minutes}`;
      return newTime;
    }
    return "";
  };

  const fetchBookingDataFromPaymentLink = (data: any) => {
    if (!data || Object.keys(data).length === 0) return;

    setBookingDate(convertDateFormat(data.booking_date));
    setBookingTime(data.booking_time);

    setPaymentInformation({ ...data.payment_information });
    setLeadInformation({ ...data.lead_information });
    setExpertInformation({ ...data.expert_information });

    setCartInformation({ ...data.cart_information });

    setIsProvisional(data.non_app);
    setIsCorporate(data.expert_billing_details?.isCorporate === "true" ? "yes" : "no");
    setSource(data.expert_billing_details?.booking_source);
    setSessionCount(data.subscription?.session_count || 1);
    setSubscriptionInformation({ ...data.subscription });
  };

  useEffect(() => {
    fetchExperts();
  }, []);

  useEffect(() => {
    if (bookingData) {
      fetchBookingDataFromPaymentLink(bookingData);
    }
  }, [bookingData]);
  return (
    <div className="main-wrapper">
      <div className="page_title py-2">Bookings - Provisional Bookings</div>
      <div className="p-5">
        <div className="row m-0 justify-content-center">
          {/* <h1 className="mb-4">Provisional Booking</h1> */}
          <div className="card p-5 col-lg-10">
            <h2>Basic Info</h2>
            <FormControl display="flex" alignItems="center">
              <FormLabel htmlFor="email-alerts" mb="5" mt="5">
                Is Provisional Booking?
              </FormLabel>
              <Switch
                id="email-alerts"
                isChecked={isProvisional}
                onChange={handleSwitchChange}
                isDisabled={!isLoggedInUserAllowed}
              />
            </FormControl>
            <form
              className="add_assesment_form"
              onSubmit={(e: any) => handleSubmit(e)}
            >
              <div className="form-row">
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="booking_date">
                    Booking Date
                  </label>
                  <input
                    value={bookingDate}
                    onChange={handleBookingDateChange}
                    type="date"
                    className="form-control"
                    id="booking_date"
                    name="booking_date"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="booking_time">
                    Booking Time
                  </label>
                  <input
                    value={bookingTime}
                    onChange={handleBookingTimeChange}
                    type="time"
                    className="form-control"
                    id="booking_time"
                    name="booking_time"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="booking_time">
                    Session Date
                  </label>
                  <input
                    value={sessionDate}
                    onChange={handleSessionDateChange}
                    type="date"
                    className="form-control"
                    id="session_date"
                    name="session_date"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="booking_time">
                    Session Time
                  </label>
                  <input
                    value={sessionTime}
                    onChange={handleSessionTimeChange}
                    type="time"
                    className="form-control"
                    id="session_time"
                    name="session_time"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Session Type
                  </label>
                  <select
                    name="session_type"
                    value={bookingDetails.session_type}
                    onChange={handleChange}
                    className="form-control"
                    id="session_type"
                  >
                    <option value="">Select Session Type</option>
                    <option value="personal">Personal</option>
                    <option value="couple">Couple</option>
                    <option value="family">Family</option>
                    <option value="child">Child</option>
                  </select>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Booking Type
                  </label>
                  <select
                    required
                    name="booking_type"
                    value={bookingDetails.booking_type}
                    onChange={handleChange}
                    className="form-control"
                    id="booking_type"
                  >
                    <option value="">Select Session Type</option>
                    <option value="couple">Couple</option>
                    <option value="inperson">Inperson</option>
                    <option value="video">Video</option>
                    <option value="call">Call</option>
                    <option value="chat">Chat</option>
                  </select>
                </div>

                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Session Count
                  </label>
                  <select
                    required
                    name="session_count"
                    value={sessionCount}
                    onChange={(e) => setSessionCount(e.target.value)}
                    className="form-control"
                    id="session_count"
                  >
                    <option value="">Select </option>
                    <option value="1">1</option>
                    <option value="3">3</option>
                    <option value="5">5</option>
                    <option value="10">10</option>
                  </select>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Booking Status
                  </label>
                  <select
                    name="booking_status"
                    value={bookingDetails.booking_status}
                    onChange={handleChange}
                    className="form-control"
                    id="booking_status"
                  >
                    <option value="">Select</option>
                    <option value="BOOKED">Booked</option>
                    <option value="RESCHEDULED">Resheduled</option>
                    <option value="CANCELLED">Canceled</option>
                  </select>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Post Booking Status
                  </label>
                  <select
                    name="booking_type"
                    onChange={(e) => setBookingPostStatus(e.target.value)}
                    className="form-control"
                    id="booking_type"
                  >
                    <option value="">Select </option>
                    <option value="NO_SHOW">No Show</option>
                    <option value="SUCCESSFUL">Successful</option>
                    <option value="RESCHEDULED">Rescheduled</option>
                    <option value="PARTIAL_SESSION">Partial Session</option>
                    <option value="EXPERT_LEVEL_ISSUE">
                      Expert Level Issue
                    </option>
                    <option value="USER_LEVEL_ISSUE">User Level Issue</option>
                  </select>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="state">
                    Session Duration
                  </label>
                  <input
                    value={bookingDetails.session_duration}
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="session_duration"
                    name="session_duration"
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Select Expert:
                  </label>
                  <Select
                    id="expert"
                    name="expert"
                    options={options}
                    placeholder="Choose Expert"
                    isClearable
                    value={options.find(
                      (option: any) => option.value === expertInformation.uuid
                    )}
                    onChange={(option) =>
                      handleExpertDetails(option ? option.value : null)
                    }
                    classNamePrefix="react-select"
                  />
                </div>

                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Booking Source
                  </label>
                  <select
                    required
                    name="booking_type"
                    value={source}
                    onChange={(e) => setSource(e.target.value)}
                    className="form-control"
                    id="booking_type"
                  >
                    <option value="">Select Source</option>
                    <option value="APP">App</option>
                    <option value="WIX">Wix</option>
                    <option value="OTHER">Other</option>
                    {/* <option value="chat">Chat</option> */}
                  </select>
                </div>

                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Is Corporate?
                  </label>
                  <select
                    name="booking_type"
                    value={isCorporate}
                    onChange={(e) => setIsCorporate(e.target.value)}
                    className="form-control"
                    id="booking_type"
                  >
                    <option value="">Select </option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
              </div>

              <div className="form-row">
                {/* <h2 className="form-group col-md-12 mb-4">
                  Physical Session Address
                </h2>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Address
                  </label>
                  <input
                    onChange={handlePhysicalSessionChange}
                    type="text"
                    className="form-control"
                    id="address"
                    name="address"
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    City
                  </label>
                  <input
                    onChange={handlePhysicalSessionChange}
                    type="text"
                    className="form-control"
                    id="city"
                    name="city"
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="gender">
                    State
                  </label>
                  <input
                    onChange={handlePhysicalSessionChange}
                    type="text"
                    className="form-control"
                    id="state"
                    name="state"
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="state">
                    Pin Code
                  </label>
                  <input
                    onChange={handlePhysicalSessionChange}
                    type="text"
                    className="form-control"
                    id="pin_code"
                    name="pin_code"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="state">
                    Latitude
                  </label>
                  <input
                    onChange={handlePhysicalSessionChange}
                    type="text"
                    className="form-control"
                    id="latitude"
                    name="latitude"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="state">
                    Longitude
                  </label>
                  <input
                    onChange={handlePhysicalSessionChange}
                    type="text"
                    className="form-control"
                    id="longitude"
                    name="longitude"
                  />
                </div> */}

                <h2 className="form-group col-md-12 mb-4">Cart Information</h2>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Promo Code
                  </label>
                  <input
                    onChange={handleCartChange}
                    type="text"
                    className="form-control"
                    id="promocode"
                    name="promocode"
                  />
                </div>
                {/* <div className="form-group col-md-3 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Subscription
                  </label>
                  <select
                    name="subscription"
                    onChange={handleCartChange}
                    className="form-control"
                    id="subscription"
                  >
                    <option value="">Select</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
                <div className="form-group col-md-3 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Pro
                  </label>
                  <select
                    name="pro"
                    onChange={handleCartChange}
                    className="form-control"
                    id="pro"
                  >
                    <option value="">Select</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div> */}
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Original Price
                  </label>
                  <input
                    value={cartInformation.original_price}
                    onChange={handleCartChange}
                    type="text"
                    className="form-control"
                    id="original_price"
                    name="original_price"
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Final Price
                  </label>
                  <input
                    value={cartInformation.final_price}
                    onChange={handleCartChange}
                    type="text"
                    className="form-control"
                    id="final_price"
                    name="final_price"
                  />
                </div>
                {/* <h2 className="form-group col-md-12 mb-4">
                  {" "}
                  Subscription Info
                </h2>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Session Count
                  </label>
                  <input
                    onChange={handleSubscriptionChange}
                    type="text"
                    className="form-control"
                    id="session_count"
                    name="session_count"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Session Price
                  </label>
                  <input
                    onChange={handleSubscriptionChange}
                    type="text"
                    className="form-control"
                    id="price"
                    name="price"
                  />
                </div> */}
                <h2 className="form-group col-md-12 mb-4"> Lead Information</h2>
                {/* <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Uuid
                  </label>
                  <input
                    onChange={handleLeadChange}
                    type="text"
                    className="form-control"
                    id="uuid"
                    name="uuid"
                  />
                </div> */}
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    First Name
                  </label>
                  <input
                    value={leadInformation.first_name}
                    onChange={handleLeadChange}
                    type="text"
                    className="form-control"
                    id="first_name"
                    name="first_name"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Last Name
                  </label>
                  <input
                    onChange={handleLeadChange}
                    type="text"
                    className="form-control"
                    id="last_name"
                    name="last_name"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Email
                  </label>
                  {isProvisional ? (
                    <input
                      value={leadInformation.email}
                      onChange={handleLeadChange}
                      type="text"
                      className="form-control"
                      id="email"
                      name="email"
                    />
                  ) : (
                    <Select
                      id="user"
                      name="user"
                      options={userOptions}
                      placeholder="Choose User Email"
                      isClearable
                      value={userOptions.find(
                        (option: any) => option.value === leadInformation.uuid
                      )}
                      onChange={(option) =>
                        handleUseretails(option ? option.value : null)
                      }
                      classNamePrefix="react-select"
                    />
                  )}
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Phone
                  </label>
                  <input
                    value={leadInformation.phone}
                    onChange={handleLeadChange}
                    type="text"
                    className="form-control"
                    id="phone"
                    name="phone"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_time">
                    Age
                  </label>
                  <input
                    onChange={handleTherapyChange}
                    type="text"
                    className="form-control"
                    id="age"
                    name="age"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_time">
                    Gender
                  </label>
                  <input
                    onChange={handleTherapyChange}
                    type="text"
                    className="form-control"
                    id="gender"
                    name="gender"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_time">
                    Symptoms
                  </label>
                  <MultiSelect
                    options={Issues}
                    labelledBy="Select Symptoms"
                    value={symptoms}
                    onChange={setSymptoms}
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Notes
                  </label>
                  <input
                    onChange={handleTherapyChange}
                    type="text"
                    className="form-control"
                    id="notes"
                    name="notes"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="booking_time">
                    Comment
                  </label>
                  <input
                    // value={sessionTime}
                    onChange={handleChange}
                    name="comment"
                    type="text"
                    className="form-control"
                    id="comment"
                  />
                </div>

                {isCorporate === "yes" && (
                  <div className="form-group col-md-6 mb-4">
                    <label className="form-label" htmlFor="state">
                      Corporate
                    </label>
                    <select
                      name="acccessCode"
                      onChange={(e) => setAccessCode(e.target.value)}
                      className="form-control"
                      id="acccessCode"
                    >
                      <option value="">Choose Corporate</option>
                      <option value="PERIFERRY">Periferry</option>
                      <option value="PERIFERRY06">Periferry06</option>
                      <option value="JELLY2D8">Jellyfish</option>
                      <option value="BHUMIX01">Bhumi</option>
                      <option value="CredXMano">Credences</option>
                      <option value="ManoSXUno">Unominda</option>
                      <option value="ManoSXFUJI">Fuji</option>
                      <option value="MANOXSIFF">Siff</option>
                      <option value="MANOXSOF">Steel-o-fab</option>
                      <option value="MANOXDEHAT">Dehat</option>
                      <option value="MANOSHALATEAM">Manoshala</option>
                    </select>
                  </div>
                )}

                {isCorporate === "yes" && (
                  <div className="form-group col-md-6 mb-4">
                    <button
                      type="button"
                      onClick={validateCorporateBooking}
                      className="btn action-btn  py-2  px-5"
                      style={{ marginTop: "30px" }}
                    >
                      Validate
                    </button>
                  </div>
                )}
                {/* <h2 className="form-group col-md-12 mb-4">
                  {" "}
                  Expert Information
                </h2>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Uuid
                  </label>
                  <input
                    onChange={handleExpertChange}
                    type="text"
                    className="form-control"
                    id="uuid"
                    name="uuid"
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Full Name
                  </label>
                  <input
                    onChange={handleExpertChange}
                    type="text"
                    className="form-control"
                    id="full_name"
                    name="full_name"
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Role
                  </label>
                  <select
                    name="role"
                    onChange={handleExpertChange}
                    className="form-control"
                    id="role"
                  >
                    <option value="">Select Role</option>
                    <option value="clinical_psychologist">
                      Clinical Psychologist
                    </option>
                    <option value="psychiatrist">Psychiatrist</option>
                    <option value="counseling_psychologist">
                      Counseling Psychologist
                    </option>
                    <option value="creative_art_therapist">
                      Creative Art Therapist
                    </option>
                    <option value="yoga_or_meditation_expert">
                      Yoga or Meditation Expert
                    </option>
                  </select>
                </div> */}
                {/* <h2 className="form-group col-md-12 mb-4">
                  {" "}
                  Payment Information
                </h2>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Amount
                  </label>
                  <input
                    onChange={handlePaymentChange}
                    type="text"
                    className="form-control"
                    id="amount"
                    name="amount"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Payment Id
                  </label>
                  <input
                    onChange={handlePaymentChange}
                    type="text"
                    className="form-control"
                    id="payment_id"
                    name="payment_id"
                  />
                </div>
                <h2 className="form-group col-md-12 mb-4">
                  {" "}
                  Manoshala PRO Information
                </h2>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Term Length
                  </label>
                  <input
                    onChange={handleProChange}
                    type="text"
                    className="form-control"
                    id="term_length"
                    name="term_length"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Price
                  </label>
                  <input
                    onChange={handleProChange}
                    type="text"
                    className="form-control"
                    id="price"
                    name="price"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Module Name
                  </label>
                  <input
                    onChange={handleProChange}
                    type="text"
                    className="form-control"
                    id="module"
                    name="module"
                  />
                </div>
                <h2 className="form-group col-md-12 mb-4">
                  {" "}
                  Therapy Plus Information
                </h2>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Term Length
                  </label>
                  <input
                    onChange={handleTherapyPlusChange}
                    type="text"
                    className="form-control"
                    id="term_length"
                    name="term_length"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Price
                  </label>
                  <input
                    onChange={handleTherapyPlusChange}
                    type="text"
                    className="form-control"
                    id="price"
                    name="price"
                  />
                </div> */}
                {/* <h2 className="form-group col-md-12 mb-4">
                  {" "}
                  Therapy Note Information
                </h2> */}
                {/* <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_time">
                    Age
                  </label>
                  <input
                    onChange={handleTherapyChange}
                    type="text"
                    className="form-control"
                    id="age"
                    name="age"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_time">
                    Gender
                  </label>
                  <input
                    onChange={handleTherapyChange}
                    type="text"
                    className="form-control"
                    id="gender"
                    name="gender"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_time">
                    Symptoms
                  </label>
                  <MultiSelect
                    options={Issues}
                    labelledBy="Select Symptoms"
                    value={symptoms}
                    onChange={setSymptoms}
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Notes
                  </label>
                  <input
                    onChange={handleTherapyChange}
                    type="text"
                    className="form-control"
                    id="notes"
                    name="notes"
                  />
                </div> */}
              </div>
              <button
                type="submit"
                className="btn action-btn mt-3 px-5 submit-button"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
